import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Button, FieldGroup, Input, Label } from "../components/ui";

export function ResetPasswordScreen() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const navigate = useNavigate();
  const [valid, setValid] = useState<boolean | null>(null);
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (!token) { setValid(false); return; }
    api.validateResetToken(token).then((r) => setValid(r.valid)).catch(() => setValid(false));
  }, [token]);

  if (valid === false) {
    return (
      <div className="mx-auto max-w-md px-4 py-16 text-center">
        <h1 className="font-display text-2xl text-crimson">Link non valido</h1>
        <p className="mt-2 text-sm text-ink-dim">Il token è scaduto o già usato.</p>
        <Button className="mt-6" onClick={() => navigate("/")}>Torna al login</Button>
      </div>
    );
  }

  if (done) {
    return (
      <div className="mx-auto max-w-md px-4 py-16 text-center">
        <h1 className="font-display text-2xl text-emerald">Password aggiornata</h1>
        <Button className="mt-6" onClick={() => navigate("/")}>Accedi</Button>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-md px-4 py-12">
      <h1 className="mb-6 font-display text-2xl">Reimposta password</h1>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          if (pw !== confirm) { setErr("Le password non coincidono"); return; }
          try {
            await api.resetPassword(token, pw);
            setDone(true);
          } catch (e2) {
            setErr(e2 instanceof Error ? e2.message : "Errore");
          }
        }}
        className="flex flex-col gap-4"
      >
        {err && <div className="rounded-lg border border-crimson-dim bg-crimson-dim/10 px-3 py-2 text-sm text-crimson">{err}</div>}
        <FieldGroup>
          <Label>Nuova password (min 6)</Label>
          <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required />
        </FieldGroup>
        <FieldGroup>
          <Label>Conferma</Label>
          <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
        </FieldGroup>
        <Button type="submit" disabled={valid === null}>{valid === null ? "Verifica…" : "Aggiorna password"}</Button>
      </form>
    </div>
  );
}
